// import actionTypes from '../actions/types';
import actionFactoryTypes from '../actions/actionsFactory/types';

export const INITIAL_STATE = {
  webauthnRequestId: '',
  webauthnCreationOptions: {},
  webauthnCredential: {},
  webauthnQuery: [],
  webauthnOriginSupported: false,
  webauthnLoginStatus: false,
  webauthnResetPasswordStatus: false,
  webauthnWithdrawAndApiStatus: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionFactoryTypes.SET_WEBAUTHN_START_REGISTER:
      return {
        ...state,
        webauthnRequestId: action.data.requestId,
        webauthnCreationOptions: action.data.creationOptions,
      };
    case actionFactoryTypes.SET_WEBAUTHN_CREATE_CREDENTIAL:
      return { ...state, webauthnCredential: action.data };
    case actionFactoryTypes.SET_WEBAUTHN_START_AUTHENTICATE:
      return {
        ...state,
        webauthnRequestId: action.data.requestId,
        webauthnCreationOptions: action.data.creationOptions,
      };
    case actionFactoryTypes.SET_WEBAUTHN_CREATE_AUTHENTICATE:
      return { ...state, webauthnCredential: action.data };
    case actionFactoryTypes.SET_WEBAUTHN_QUERY:
      return { ...state, webauthnQuery: action.data };
    case actionFactoryTypes.SET_WEBAUTHN_ORIGIN_SUPPORTED:
      return { ...state, webauthnOriginSupported: action.data };
    case actionFactoryTypes.SET_SECURITY_KEY_STATUS:
      return {
        ...state,
        webauthnLoginStatus: action.data.login,
        webauthnResetPasswordStatus: action.data.resetPassword,
        webauthnWithdrawAndApiStatus: action.data.withdrawAndApi,
      };
    default:
      return state;
  }
};
